// Chakra imports
import { Box, Stack } from "@chakra-ui/react";
import { ArgonLogoLight, ChakraLogoLight } from "components/Icons/Icons";
import { useStore } from "@nanostores/react";
import MainPanel from "components/Layout/MainPanel";
import PanelContainer from "components/Layout/PanelContainer";
import PanelContent from "components/Layout/PanelContent";
import Sidebar from "components/Sidebar/Sidebar.js";
import { SidebarContext } from "contexts/SidebarContext";
import React, { useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { userProfile } from "contexts/userProfile.js";
import routes from "routes.js";

const Landing = () => {
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const [sidebarWidth, setSidebarWidth] = useState(275);

  const { auth } = useStore(userProfile);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/landing") {
        return <Route path={prop.path} component={prop.component} key={key} />;
      }
      if (prop.collapse) {
        return getRoutes(prop.items);
      }
      if (prop.category) {
        return getRoutes(prop.items);
      } else {
        return null;
      }
    });
  };

  return (
    <Box minH="100vh">
      <MainPanel
        w={{
          base: "100%",
          xl: "100%",
        }}
        minH="100vh"
      >
        <PanelContent>
          <PanelContainer>
            <Switch>{getRoutes(routes)}</Switch>
          </PanelContainer>
        </PanelContent>
      </MainPanel>
    </Box>
  );
};

export default Landing;
